import { PaginationState } from "@tanstack/react-table";

export const visibleOperationStatusOptions = [
  "processing",
  "approved",
  "rejected",
  "completed",
] as const;

export type OperationVisibleStatus =
  (typeof visibleOperationStatusOptions)[number];

export type OperationStatusFilter = "" | OperationVisibleStatus;

export interface OperationStatus {
  id: string;
  name: string;
}

export interface OperationRow {
  id: string;
  reference?: string;
  createdAt: string;
  amount: number;
  amountUsd: number;
  amountVef?: number;
  currency?: "USD" | "VEF";
  rate?: number;
  commissionAmount?: number;
  settledAmount?: number;
  bankTxId?: string;
  disbursementBankCode?: string;
  feeCount: number;
  icon?: string;
  iconColor?: string | null;
  syncError?: string;
  laStatus?: string;
  status: OperationStatus;
  clientId: string;
  clientName: string;
  clientEmail: string;
  clientDocument: string;
}

export interface OperationIndicators {
  total: number;
  void: number;
  processing: number;
  approved: number;
  rejected: number;
  completed: number;
}

export interface OperationListResult {
  data: OperationRow[];
  totalCount: number;
}

export interface OperationListParams {
  page?: number;
  limit?: number;
  excludeStatus?: string;
  globalFilter?: string;
  startDate?: string;
  endDate?: string;
  status?: OperationVisibleStatus;
}

export type OperationListPagination = PaginationState;

export const getEmptyOperationIndicators = (): OperationIndicators => ({
  total: 0,
  void: 0,
  processing: 0,
  approved: 0,
  rejected: 0,
  completed: 0,
});

export const operationStatusLabels: Record<string, string> = {
  void: "Pendiente",
  processing: "Procesando",
  approved: "Aprobado",
  rejected: "Rechazado",
  completed: "Completado",
};

export const getOperationStatusLabel = (status?: OperationStatus) =>
  (status?.id && operationStatusLabels[status.id]) ||
  status?.name ||
  "Desconocido";

export const isManualReviewLaStatus = (laStatus?: string) =>
  String(laStatus || "").startsWith("manual_review_");
